namespace Matrix.Data.Repositories {
    export interface TestRunResponse extends Serenity.ServiceResponse {
    }
}
